import React from 'react';

import style from './style/index.scss';
import { RiskCard } from './components/RiskCard';

/**
 *
 * @param {Object} props - props object
 * @param {Object} props.section - section object
 * @param {Function} props.openSingleScaleScoreModal - open modal to show a single scale score in detail
 *
 * @returns {JSX.Element} - main derailment section overview
 */
export function Risks(props) {
    const { scores, openSingleScaleScoreModal } = props;

    return (
        <div className={style.scoreCardsContainer}>
            {scores.map((score, index) => {
                if (score.score < 3) {
                    return false;
                }

                return (
                    <RiskCard
                        key={index}
                        riskAssessment={score.riskAssessment}
                        name={score.name}
                        handle={score.handle}
                        onClick={openSingleScaleScoreModal}
                    />
                );
            })}
        </div>
    );
}
